export default [
    // {
    //     path: '/objectif/:id/:year?',
    //     name: 'objectif',
    //     meta: { requiresAuth: true },  // Nécessite une authentification
    //
    //     component: () => import('@/views/objectif/ObjectivesView.vue'),
    //
    // },
    {
        path: '/objectif',
        name: 'objectif',
        meta: { requiresAuth: true },
        component: () => import('@/views/objectif/ObjectivesView.vue'),
    },

    {
        path: '/objectif/print/:id/:isRapport?',
        name: 'objectif_print',
        meta: { requiresAuth: true },  // Nécessite une authentification

        component: () => import('@/views/objectif/ObjectiveForm.vue'),
        // meta: {
        //     pageTitle: 'Objective',
        //     breadcrumb: [
        //       {
        //         text: 'Objective',
        //         active: true,
        //       },
        //     ],        
        // },
      },
    
]